import * as Focus from '../common/focus';

window.addEventListener('load', function () {
  const toggleSearch = document.querySelector('.toggleSearch');
  const searchModal = document.querySelector('.site-header > #search-modal');
  const closeSearch = document.querySelector(
    '.site-header > #search-modal .search-modal__heading #search-close'
  );
  const dropdowns = document.querySelectorAll('.nav-primary .dropdown');

  function closeSearchModal() {
    searchModal.classList.remove('opened');
    toggleSearch.setAttribute('aria-expanded', 'false');
    closeSearch.setAttribute('aria-expanded', 'false');

    if (searchModal.classList.contains('search-modal--window')) {
      Focus.untrapFocusInside(jQuery('#search-modal'));
      document.documentElement.classList.remove('lockedPosition');
    }
  }

  function openSearchModal() {
    const openEvent = new Event('opensearchmodal');
    searchModal.classList.add('opened');
    toggleSearch.setAttribute('aria-expanded', 'true');
    closeSearch.setAttribute('aria-expanded', 'true');
    window.dispatchEvent(openEvent);

    if (searchModal.classList.contains('search-modal--window')) {
      Focus.trapFocusInside(jQuery('#search-modal'));
      document.documentElement.classList.add('lockedPosition');
    }
  }

  if (toggleSearch && closeSearch) {
    toggleSearch.addEventListener('click', function () {
      if (searchModal.classList.contains('opened')) {
        closeSearchModal();
      } else {
        openSearchModal();
      }
    });

    closeSearch.addEventListener('click', function () {
      if (searchModal.classList.contains('opened')) {
        closeSearchModal();
      }
    });

    // close search bar when dropdown opens from hover
    if (
      0 < dropdowns.length &&
      !searchModal.classList.contains('search-modal--window')
    ) {
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('mouseover', function () {
          if (searchModal.classList.contains('opened')) {
            closeSearchModal();
          }
        });
      });
    }
  }
});

//Do not display empty result on fisrt loading page
const findstr = window.findstr || {};

findstr.hooks.addFilter(
  'findstrEmptyResultsMessageOnInit',
  'findstr-search-overlay',
  function (setEmptyAlertOnInit, group) {
    if ('search' === group) {
      return false;
    }
    return setEmptyAlertOnInit;
  }
);

document.addEventListener('findstrLoaded', () => {
  const searchForm = document.querySelectorAll('.search-form');
  if (searchForm.length > 0) {
    searchForm.forEach((searchFormItem) => {
      const inputSearch = searchFormItem.querySelector('.search-field');
      if (inputSearch) {
        inputSearch.addEventListener('focus', () => {
          searchFormItem.classList.add('search_autocomplete_active');
        });
        inputSearch.addEventListener('blur', () => {
          setTimeout(() => {
            searchFormItem.classList.remove('search_autocomplete_active');
          }, 200);
        });
      }
    });
  }

  findstr.hooks.addFilter(
    'urlManagementDisabled',
    'restauration',
    (disabled, group) => {
      if ('search-autocomplete' === group || 'search' === group) {
        return true;
      }
      return disabled;
    }
  );
});
